import React from 'react';

import type { TableColumn } from '../types';

import { TableCell } from './TableCell';
import { TableHeader } from './TableHeader';

interface TableSkeletonProps<T> {
  columns: TableColumn<T>[];
  rows: number;
  toolbar?: React.ReactNode;
}

export const TableSkeleton = <T,>({
  columns,
  rows,
  toolbar
}: TableSkeletonProps<T>) => {
  // Skeleton headers are never interactive — a loading state shouldn't
  // expose a live "select all" control (or any other custom header)
  // while the rows underneath are just placeholder bars. Only the columns
  // that actually define one get a new object; the rest keep their
  // original reference in this single pass.
  const skeletonColumns = columns.map(column =>
    column.renderHeader ? { ...column, renderHeader: undefined } : column
  );

  return (
    <div className="w-full border border-[#EEEFF2] rounded-lg overflow-hidden">
      {toolbar}
      <TableHeader columns={skeletonColumns} />
      <div className="bg-white">
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <div key={rowIndex} className="flex">
            {columns.map(column => (
              <TableCell key={column.key} width={column.width}>
                <div className="h-4 w-full bg-gray-100 rounded animate-pulse"></div>
              </TableCell>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
